import { connect } from 'react-redux';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import {
    deleteGroupsFromDomains,
} from '../../../common/actions/domain-groups-action-creators';
import ActionButton from './action-button';


export class RemoveFromGroupButtonContainer extends Component{
    handleRemoveFromGroupsChange = ( groupId ) => {
        const { selectedDomains, deleteGroupsFromDomains } = this.props;
        deleteGroupsFromDomains( selectedDomains.map( domain => domain.domainName ) );
    }

    render(){
        return (
            <ActionButton
                dataId="domain-management-remove-from-group-button"
                onClick={this.handleRemoveFromGroupsChange}
            >
                Remove from groups
            </ActionButton>
        );
    }
};

RemoveFromGroupButtonContainer.propTypes = {
    deleteGroupsFromDomains: PropTypes.func.isRequired,
    selectedDomains: PropTypes.array.isRequired,
};

export default connect( null, { deleteGroupsFromDomains } )( RemoveFromGroupButtonContainer );
